import { motion, useReducedMotion } from 'framer-motion';

const CHAPTERS = [
    {
        no: '01',
        title: 'The Family',
        body: 'Asteraceae — the daisy or sunflower family — is among the largest families of flowering plants on earth. What looks like a single flower is in fact a composite head: dozens of tiny ray and disc florets packed into one capitulum, an architecture of deception perfected over fifty million years.',
        meta: 'Compositae · c. 32,000 species worldwide',
    },
    {
        no: '02',
        title: 'The Region',
        body: 'Western Vidarbha, centred on the Amravati district of Maharashtra — a landscape of wastelands, fallow fields, forest edges and village commons. Here the family thrives as gregarious colonisers, quiet herbs and cultivated escapes, flowering through the monsoon and into the cold season.',
        meta: 'Amravati · Maharashtra · India',
    },
    {
        no: '03',
        title: 'The Collection',
        body: 'Seventy-two species gathered plate by plate. Every record holds nomenclature and synonyms, tribe and subtribe, habit and habitat, native range and occurrence, key characters, a full botanical description, flowering and fruiting, distribution, ecology and economic importance.',
        meta: '14 fields per specimen · 3 plates each',
    },
];

const Chapter = ({ chapter, index }) => {
    const reduce = useReducedMotion();
    return (
        <motion.div
            initial={reduce ? false : { opacity: 0, y: 48 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-15%' }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
            className={`grid gap-6 border-t border-line py-20 md:grid-cols-12 md:py-28 ${index === 0 ? 'border-t-0' : ''}`}
            data-testid={`chapter-${chapter.no}`}
        >
            <div className="md:col-span-4">
                <span className="font-serif text-[7rem] italic leading-none text-terra/25 md:text-[11rem]">{chapter.no}</span>
            </div>
            <div className="md:col-span-7 md:col-start-6">
                <h3 className="font-serif text-4xl italic text-ink md:text-6xl">{chapter.title}</h3>
                <p className="mt-6 max-w-xl text-sm leading-relaxed text-ink/70 md:text-base">{chapter.body}</p>
                <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.3em] text-mute">{chapter.meta}</p>
            </div>
        </motion.div>
    );
};

export const Chapters = () => (
    <section id="chapters" data-testid="chapters-section" className="mx-auto max-w-[1500px] px-5 py-24 md:px-10 md:py-36">
        <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="mb-16 font-mono text-[11px] uppercase tracking-[0.3em] text-terra"
        >
            A manifesto in three chapters
        </motion.p>
        {CHAPTERS.map((c, i) => (
            <Chapter key={c.no} chapter={c} index={i} />
        ))}
    </section>
);
